import { Avatar as MUIAvatar, Link, Tooltip, useTheme, SxProps, Theme } from '@mui/material';
//  @ts-ignore
import randomMC from 'random-material-color';
import NextLink from 'next/link';
import useAuth from 'src/hooks/useAuth';
import { PATH_APP } from 'src/routes/paths';
// ----------------------------------------------------------------------

/**
 * AvatarのLinkを有効にするにはtypeとidの両方が必要
 *
 * @param {string} tooltip - Tooltip有効化
 * @param {string} isLink - Link有効化
 *
 */

type Props = {
  alt: string;
  id: string;
  sx?: SxProps<Theme> | null;
  src: string;
  tooltip?: boolean | null;
  isLink?: boolean | null;
};
// TODO user, teamをpropsで受け取れるようにする
// とりあえず部門アイコンの時はisLinkにfalseを渡す
export const CustomAvatar = ({ alt, id, sx, src, tooltip = true, isLink = true }: Props) => {
  const { organization } = useAuth();
  return (
    <>
      {isLink && id ? (
        <NextLink
          href={{
            pathname: PATH_APP.organization.members.member.root,
            query: { organizationName: organization, userID: id },
          }}
          passHref
          legacyBehavior
        >
          <Link underline="none">
            <AvatarWithTooltip alt={alt} sx={sx} src={src} tooltip={tooltip} />
          </Link>
        </NextLink>
      ) : (
        <AvatarWithTooltip alt={alt} sx={sx} src={src} tooltip={tooltip} />
      )}
    </>
  );
};

const AvatarWithTooltip = (props: any) => {
  const { alt, sx, tooltip = true, src } = props;

  const theme = useTheme();
  return (
    <>
      {tooltip ? (
        <Tooltip title={alt ?? ''} arrow>
          <MUIAvatar
            src={src}
            sx={{
              fontWeight: theme.typography.fontWeightMedium,
              color: '#FFFFFF!important',
              backgroundColor: randomMC.getColor({ text: alt }),
              width: 40,
              height: 40,
              fontSize: 16,
              ...sx,
            }}
          >
            {alt ? alt.substring(0, 2) : ''}
          </MUIAvatar>
        </Tooltip>
      ) : (
        <MUIAvatar
          src={src}
          sx={{
            fontWeight: theme.typography.fontWeightMedium,
            color: '#FFFFFF!important',
            backgroundColor: randomMC.getColor({ text: alt }),
            width: 40,
            height: 40,
            fontSize: 16,
            ...sx,
          }}
        >
          {alt ? alt.substring(0, 2) : ''}
        </MUIAvatar>
      )}
    </>
  );
};
